export default "__VITE_ASSET__I4xCEv5I__"